<script setup>
import RichTextIcon from '~icons/solar/document-text-linear';

const props = defineProps({
  task_uid: {
    type: String,
    required: true,
  },
  fields_list: {
    type: Array,
    default: () => [],
  },
  submit: {
    type: Function,
    default: () => {
      return true;
    },
  },
  attachment_config: {
    type: Object,
    default: null,
  },
  texts: {
    type: Object,
    default: () => {
      const $t = inject('$t');
      return {
        title: $t('File Upload'),
        subtitle: $t('files-uploaded-to-project'),
      };
    },
  },
});

const emit = defineEmits(['close']);

const form = ref({});
const form$ = ref({});
const uploading = ref(null);

const state = reactive({
  is_submitting: false,
  is_upload_enabled: false,
});

function onFormMounted() {
  form$.value.elements$.File.input.click();
}
const show_description_input = ref(false);
const is_file_selected = computed(() => {
  if (props.is_single_file)
    return !!form.value?.File;
  return !!(form.value?.File && form.value.File.length);
});
function onFormUpdated(event) {
  if (event.type === 'upload_started') {
    uploading.value = true;
    state.is_upload_enabled = false;
  }
  else if (event.type === 'upload_completed') {
    uploading.value = false;
    state.is_upload_enabled = true;
  }
}

function cancelUpload() {
  form$.value.uppy.cancelAll();
  emit('close');
}

async function onSubmit() {
  state.is_submitting = true;
  await props.submit(form$.value);
  state.is_submitting = false;
}
</script>

<template>
  <hawk-modal-container>
    <Vueform
      ref="form$"
      v-model="form"
      :display-errors="false"
      :should_validate_on_mount="false"
      :attachment_config="props.attachment_config || { meta: { service: 'tickets', id: task_uid } }"
      :presets="['disable_error_messages']"
      :loading="uploading"
      @mounted="onFormMounted"
      @updated="onFormUpdated"
    >
      <div class="col-span-12">
        <hawk-modal-header @close="emit('close')">
          <template #icon>
            <RichTextIcon />
          </template>
          <template #title>
            {{ props.texts.title }}
          </template>
          <template #subtitle>
            <div class="text-gray-600">
              {{ props.texts.subtitle }}
            </div>
          </template>
        </hawk-modal-header>
        <!-- Body -->
        <hawk-modal-content class="!py-0">
          <component
            :is="component.component" v-for="component in fields_list" :key="component.name" class="pt-4 mb-8"
            v-bind="component"
          />
          <div v-if="is_file_selected" class="mb-8">
            <p v-if="!show_description_input" class="mb-2 text-sm text-gray-600 cursor-pointer" @click="show_description_input = !show_description_input">
              + {{ $t('Add description') }}
            </p>
            <TextareaElement
              v-if="show_description_input"
              name="note"
              autocomplete="off"
              :placeholder="$t('Add description')"
            />
          </div>
        </hawk-modal-content>
        <hawk-modal-footer>
          <!-- Footer -->
          <template #right>
            <div class="flex justify-end w-full">
              <HawkButton type="outlined" text="Cancel" class="mr-2" @click="cancelUpload">
                {{ $t('Cancel') }}
              </HawkButton>
              <ButtonElement
                size="sm"
                name="submit"
                :button-label="$t('Upload')"
                :loading="state.is_submitting"
                :disabled="!state.is_upload_enabled"
                button-class="vf-btn-primary"
                @click="onSubmit"
              />
            </div>
          </template>
        </hawk-modal-footer>
      </div>
    </Vueform>
  </hawk-modal-container>
</template>
